var styles = {"buttonWrapper":"VBG__DS__button-module__2-yr2","darkBrandHighlight":"VBG__DS__button-module__n5Ji4","brandHighlight":"VBG__DS__button-module__1VK6S"};

export { styles as default };
